import styled from "styled-components";

export const StyledJumbotron = styled.div`
  background-size: cover;
  background-height: 100px;
  padding-top: 20px;
  color: #000;
  background-color: #fff;

  .wrapper {
    background-color: #fafafa;
  }

  .iframeHeader {
    color: black;
    padding-top: 35px;
    font-size: 32px;
    margin-bottom: 0;
    text-align: center;
  }
`;
